import React from 'react';

interface Props {
  title: string;
  body: string;
  imageUrl: string | null;
  /** Ícone do app (logo padrão do Storage). No celular, quem define o ícone é o próprio app. */
  appIcon: string | null;
}


/** Prévia aproximada de como a notificação aparece no Android e no iPhone. */
const PushPreview: React.FC<Props> = ({ title, body, imageUrl, appIcon }) => {
  const shownTitle = title.trim() || 'Título da notificação';
  const shownBody = body.trim() || 'Mensagem da notificação';
  // Mesmo ícone do app instalado (FIAMImages/logo-meu-negocio.png). Enquanto não
  // carrega, só o quadrado azul — nunca a logo com texto do menu do painel.
  const renderIcon = (style: React.CSSProperties) =>
    appIcon ? <img src={appIcon} alt="" style={style} /> : <span style={{ ...style, ...styles.iconPlaceholder }} />;

  return (
    <div style={styles.container}>
      <div style={styles.caption}>Prévia</div>

      <div style={styles.platformLabel}>Android</div>
      <div style={styles.android}>
        <div style={styles.androidHeader}>
          {renderIcon(styles.androidIcon)}
          <span>Meu Negócio · agora</span>
        </div>
        <div style={styles.row}>
          <div style={styles.texts}>
            <div style={styles.title}>{shownTitle}</div>
            <div style={styles.body}>{shownBody}</div>
          </div>
          {imageUrl && <img src={imageUrl} alt="" style={styles.thumbnail} />}
        </div>
      </div>

      <div style={styles.platformLabel}>iPhone</div>
      <div style={styles.ios}>
        {renderIcon(styles.iosIcon)}
        <div style={styles.texts}>
          <div style={styles.iosHeader}>
            <span style={styles.title}>{shownTitle}</span>
            <span style={styles.iosTime}>agora</span>
          </div>
          <div style={styles.body}>{shownBody}</div>
        </div>
        {imageUrl && <img src={imageUrl} alt="" style={styles.thumbnail} />}
      </div>
    </div>
  );
};

const clamp = (lines: number): React.CSSProperties => ({
  display: '-webkit-box',
  WebkitLineClamp: lines,
  WebkitBoxOrient: 'vertical',
  overflow: 'hidden',
});

const styles: { [key: string]: React.CSSProperties } = {
  container: {
    background: 'linear-gradient(160deg, #1d3a6e 0%, #3f74c7 100%)',
    borderRadius: '16px',
    padding: '20px',
  },
  caption: {
    color: 'white',
    fontWeight: 'bold',
    fontSize: '14px',
    marginBottom: '12px',
  },
  platformLabel: {
    color: 'rgba(255,255,255,0.75)',
    fontSize: '12px',
    margin: '12px 0 6px',
  },
  android: {
    background: 'white',
    borderRadius: '14px',
    padding: '12px 14px',
    boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
  },
  androidHeader: {
    display: 'flex',
    alignItems: 'center',
    gap: '6px',
    fontSize: '11px',
    color: '#5f6368',
    marginBottom: '6px',
  },
  androidIcon: {
    width: '16px',
    height: '16px',
    borderRadius: '50%',
    objectFit: 'cover',
  },
  row: {
    display: 'flex',
    gap: '10px',
    alignItems: 'flex-start',
  },
  texts: {
    flex: 1,
    minWidth: 0,
  },
  title: {
    fontWeight: 600,
    fontSize: '14px',
    color: '#202124',
    ...clamp(1),
  },
  body: {
    fontSize: '13px',
    color: '#3c4043',
    marginTop: '2px',
    ...clamp(2),
  },
  thumbnail: {
    width: '44px',
    height: '44px',
    borderRadius: '8px',
    objectFit: 'cover',
    flexShrink: 0,
  },
  ios: {
    display: 'flex',
    gap: '10px',
    alignItems: 'center',
    background: 'rgba(245,245,245,0.92)',
    borderRadius: '18px',
    padding: '12px',
  },
  iconPlaceholder: {
    display: 'inline-block',
    background: 'linear-gradient(135deg, #0D47A1 0%, #1976D2 50%, #42A5F5 100%)',
  },
  iosIcon: {
    width: '34px',
    height: '34px',
    borderRadius: '8px',
    objectFit: 'cover',
    flexShrink: 0,
  },
  iosHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    gap: '8px',
  },
  iosTime: {
    fontSize: '12px',
    color: '#8e8e93',
    flexShrink: 0,
  },
};

export default PushPreview;
